import { useState } from "react";
import toast from "react-hot-toast";
import { handleError } from "../utils/handleError";

const useContractedSpecialist = ({ loading, setLoading }) => {
  const [isContractedService, setIsContractedService] = useState(false);
  const [inforProviderContrated, setInforProviderContrated] = useState(null);
  const [error, setError] = useState(null);

  const checkContractedSpecialist = async ({
    specialistList,
    currentUserId,
    getAllSpecialistFn,
    getAllPatientsOfProviderFn,
    dispatch,
    setListSpecialistsAction,
  }) => {
    setLoading(true);
    setError(null);

    try {
      // 1. Obtener lista completa de especialistas si se proporciona la función
      if (getAllSpecialistFn && dispatch && setListSpecialistsAction) {
        const listSpecialist = await getAllSpecialistFn();
        dispatch(setListSpecialistsAction({ listSpecialist }));
      }

      // 2. Verificar pacientes de cada especialista (en paralelo)
      const patientLists = await Promise.all(
        specialistList.map(async (specialist) => {
          const listPatints = await getAllPatientsOfProviderFn(specialist._id);
          return { specialist, patients: listPatints };
        })
      );

      // 3. Encontrar si el usuario actual está en alguna lista
      let contractedSpecialist = null;
      const userIsContracted = patientLists.some(({ patients, specialist }) => {
        const isContracted = patients.some(
          (patient) => patient?.userId === currentUserId
        );
        if (isContracted) {
          contractedSpecialist = specialist;
        }
        return isContracted;
      });

      // 4. Actualizar estado según resultados
      if (userIsContracted && contractedSpecialist) {
        setInforProviderContrated(contractedSpecialist);
        setIsContractedService(true);
      } else {
        setInforProviderContrated(null);
        setIsContractedService(false);
      }

      return { contractedSpecialist, isContracted: userIsContracted };
    } catch (error) {
      const { message } = handleError(error);
      setError(message);
      toast.error(`Error al obtener especialista. \n${message}`);
      return { error: message };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    setLoading,
    isContractedService,
    inforProviderContrated,
    error,
    checkContractedSpecialist,
  };
};

export default useContractedSpecialist;
